// Clean up cache and unregister this service worker
self.addEventListener('activate', (event) => {
  event.waitUntil(
    (async () => {
      for (const key of await caches.keys()) {
        await self.caches.delete(key);
      }

      await self.registration.unregister();

      console.log('Successfully clean up service worker');
    })().catch((error) => {
      console.error(`Failed to clean up service worker: ${error.message}`)
      console.error(error);
    })
  );
});

// Force install over old service worker if it is stuck
self.addEventListener('install', () => {
  self.skipWaiting();
});

